import { render, staticRenderFns } from "./collectionSearch.vue?vue&type=template&id=2480177a&scoped=true&"
import script from "./collectionSearch.vue?vue&type=script&lang=js&"
export * from "./collectionSearch.vue?vue&type=script&lang=js&"
import style0 from "./collectionSearch.vue?vue&type=style&index=0&id=2480177a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2480177a",
  null
  
)

export default component.exports